export reducer from './reducer';

export * as actions from './actions'


/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceArea/index.js
 **/